export const config = {
  title: "Sosa's Cleaning LLC | Professional Cleaning Services in Mesquite, TX",
  meta: {
    description:
      "Sosa's Cleaning LLC provides top-notch residential, office, deep, post-construction, move-in/move-out, and window cleaning services in Mesquite, TX. Dedicated to quality and customer satisfaction.",
    keywords: [
      'Cleaning Services Mesquite TX',
      'Residential Cleaning Mesquite',
      'Office Cleaning Mesquite',
      'Deep Cleaning Mesquite',
      'Post-Construction Cleaning',
      'Move-In Cleaning',
      'Move-Out Cleaning',
      "Sosa's Cleaning LLC",
      'Texas Cleaning Services',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "Sosa's Cleaning LLC",
    canonicalUrl: 'https://sosascleaning.com/',
  },
  sections: {
    header: {
      businessName: "Sosa's Cleaning LLC",
    },
    sectionB: {
      heroTitle: "Sosa's Cleaning LLC",
      heroSubtitle: 'Transforming Spaces, Making Them Sparkle!',
      learnAboutText: 'Explore Services',
      phoneNumber: '2148594835',
      phoneLabel: '(214) 859-4835',
      heroBackgroundImage:
        'https://static.wixstatic.com/media/11062b_327964cfd02b4cb38e4010e98f30fd42~mv2.jpeg/v1/fill/w_1448,h_925,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/11062b_327964cfd02b4cb38e4010e98f30fd42~mv2.jpeg',
      cardData: [
        {
          title: 'Residential Cleaning',
          description:
            'Meticulous cleaning services for homes, ensuring a spotless and welcoming environment.',
        },
        {
          title: 'Office Cleaning',
          description:
            'Keep your workspace clean and productive with our reliable office cleaning services.',
        },
        {
          title: 'Post-Construction Cleaning',
          description:
            'Thorough cleaning after construction projects, leaving your space ready to use.',
        },
      ],
      description:
        "Sosa's Cleaning LLC offers reliable and professional cleaning services to ensure your spaces remain clean, organized, and welcoming. From homes to offices, our team handles it all with expertise and care.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Explore our wide range of cleaning services designed to cater to your specific needs. Whether it's residential, commercial, or specialized cleaning, we've got you covered.",
      cards: [
        {
          title: 'Deep Cleaning',
          description:
            'Comprehensive cleaning solutions for spaces that need extra care and attention.',
          imageSrc:
            'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/2fcf207f-9d26-4bb0-afae-5734455fee896cfb.jpg?alt=media&token=0f55e1a5-3310-47e4-87db-b0dc01d67b8f',
          imageAlt: 'Deep Cleaning Services',
        },
        {
          title: 'Window Cleaning',
          description:
            'Crystal-clear window cleaning for homes and offices, enhancing visibility and aesthetics.',
          imageSrc:
            'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/8cd670aa-04aa-422d-a4c1-bd2ae4bd09edece8.png?alt=media&token=cd990c0b-b82f-4d9b-91fc-d79207a6b60a',
          imageAlt: 'Window Cleaning Services',
        },
        {
          title: 'Move-In/Move-Out Cleaning',
          description:
            'Thorough cleaning services for tenants or landlords to prepare spaces for the next resident.',
          imageSrc:
            'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/72cfc589-9093-4e2d-baf7-dc6d179eca0149cc.jpg?alt=media&token=fd49b408-7631-4d2d-b03f-42b15e667fcc',
          imageAlt: 'Move-In/Move-Out Cleaning Services',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Residential Cleaning',
        'Post-Construction Cleaning',
        'Office Cleaning',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/7042c2e1-d4ad-46fc-b7c1-95170e6950f8899d.jpg?alt=media&token=6f2e771b-a891-4e1e-8e71-01aef0e285e2',
        alt: "Sosa's Cleaning LLC Team",
      },
      aboutText: [
        "Welcome to Sosa's Cleaning LLC, your trusted partner for cleaning services in Mesquite, TX. Our team is dedicated to creating clean, healthy, and organized spaces for both homes and offices.",
        "We specialize in residential cleaning, deep cleaning, move-in/move-out cleaning, window cleaning, post-construction cleaning, and more. With a focus on detail and customer satisfaction, Sosa's Cleaning LLC strives to exceed expectations every time.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Sosa's Cleaning LLC Logo",
      businessName: "Sosa's Cleaning LLC",
      contact: {
        phone: '2148594835',
        phoneLabel: '(214) 859-4835',
        email: 'info@sosascleaning.com',
        website: 'https://sosascleaning.com/',
        address: 'Mesquite, TX, US',
      },
      socialMedia: {
        googlePlus: 'https://business.google.com/n/11568656144107826981/searchprofile',
        linkedIn: null,
        facebook: 'https://www.facebook.com/profile.php?id=61554544004546&mibextid=2JQ9oc',
        twitter: null,
        tiktok: null,
        instagram: 'https://www.instagram.com/sosa_cleaning_services/?utm_source=qr&igsh=MXhkYXF6c21mMHY3Ng%3D%3D#',
        youtube: null,
      },
    },
    sectionF: {
      address: 'Mesquite, TX, US',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.5760110136727!2d-96.601423!3d32.766799!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e8275ef56e1e7%3A0x0!2zMzLCsDQ2JzAwLjgiTiA5NsKwMzYnMDMuMiJX!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus',
    },
  },
};

export default config;
